import i18next from "i18next";

export default function t(key, option = null) {
    return i18next.t(key, option)
};
